import React from 'react';
import { Row, Col, Button } from 'antd';
import { 
  SecurityScanOutlined, 
  DesktopOutlined, 
  DatabaseOutlined,
  ArrowRightOutlined,
  CheckCircleOutlined
} from "@ant-design/icons";

function AppAbout() {
  const features = [
    {
      key: '1',
      icon: <DesktopOutlined />,
      title: 'Built by the Community',
      content: 'Created by individuals who understand Brahmin traditions and values. Our team shares a commitment to preserving cultural essence while embracing modern matchmaking.',
      color: '#667eea'
    },
    {
      key: '2',
      icon: <SecurityScanOutlined />,
      title: 'Privacy & Security First',
      content: 'Your personal information is protected with enterprise-grade security. We ensure a safe, confidential environment for your matrimonial journey.',
      color: '#764ba2'
    },
    {
      key: '3',
      icon: <DatabaseOutlined />,
      title: 'Unity in Diversity',
      content: 'Explore diverse profiles within our community while staying rooted in shared values. Find matches across subcastes or within your specific preferences.',
      color: '#f093fb'
    }
  ];

  const values = [
    'Respect for traditional Brahmin values and customs',
    'Modern approach to finding compatible life partners',
    'Community-driven platform with cultural sensitivity',
    'Commitment to meaningful, long-term relationships'
  ];

  return (
    <div style={{ background: '#f8fafc', padding: '100px 0' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px' }}>
        
        {/* Header Section */}
        <div style={{ textAlign: 'center', marginBottom: '80px' }}>
          <div style={{
            display: 'inline-block',
            background: 'linear-gradient(135deg, #667eea, #764ba2)',
            color: 'white',
            padding: '8px 20px',
            borderRadius: '25px',
            fontSize: '14px',
            fontWeight: '500',
            marginBottom: '24px'
          }}>
            About OkBrahmin
          </div>
          
          <h2 style={{
            fontSize: 'clamp(2.5rem, 5vw, 3.5rem)',
            fontWeight: 'bold',
            color: '#1f2937',
            marginBottom: '24px',
            lineHeight: '1.2'
          }}>
            Where Tradition Meets <span style={{ color: '#667eea' }}>Technology</span>
          </h2>
          
          <p style={{
            fontSize: '1.25rem',
            color: '#6b7280',
            maxWidth: '800px',
            margin: '0 auto',
            lineHeight: '1.7'
          }}>
            Welcome to OkBrahmin, a sacred space designed exclusively for Brahmin communities to find meaningful life partnerships rooted in tradition and cultural values.
          </p>
        </div>

        {/* Story Section */}
        <Row gutter={[48, 48]} style={{ marginBottom: '100px' }} align="middle">
          <Col xs={24} lg={12}>
            <div style={{
              background: 'white',
              borderRadius: '24px',
              padding: '50px',
              boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
              height: '100%'
            }}>
              <h3 style={{
                fontSize: '2rem',
                fontWeight: 'bold',
                color: '#1f2937',
                marginBottom: '24px'
              }}>
                Our Mission
              </h3>
              
              <p style={{
                fontSize: '1.1rem',
                color: '#6b7280',
                lineHeight: '1.7',
                marginBottom: '32px'
              }}>
                We celebrate the rich cultural heritage of Brahmins, acknowledging the values, traditions, and principles that make our community unique. Our platform combines traditional wisdom with contemporary technology to facilitate meaningful connections.
              </p>

              {/* Values List */}
              <div style={{ marginBottom: '32px' }}>
                {values.map((value, index) => (
                  <div key={index} style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    marginBottom: '16px'
                  }}>
                    <CheckCircleOutlined style={{
                      color: '#667eea',
                      fontSize: '18px',
                      marginRight: '12px',
                      marginTop: '2px'
                    }} />
                    <span style={{
                      color: '#4b5563',
                      fontSize: '16px',
                      lineHeight: '1.6'
                    }}>
                      {value}
                    </span>
                  </div>
                ))}
              </div>

              <Button
                type="primary"
                size="large"
                style={{
                  background: 'linear-gradient(135deg, #667eea, #764ba2)',
                  border: 'none',
                  borderRadius: '25px',
                  height: '50px',
                  padding: '0 30px',
                  fontWeight: 'bold'
                }}
              >
                Join Our Community
                <ArrowRightOutlined style={{ marginLeft: '8px' }} />
              </Button>
            </div>
          </Col>

          <Col xs={24} lg={12}>
            {/* Stats Cards */}
            <div style={{ display: 'grid', gap: '20px', gridTemplateColumns: '1fr 1fr' }}>
              <div style={{
                background: 'linear-gradient(135deg, #667eea, #764ba2)',
                color: 'white',
                padding: '30px',
                borderRadius: '20px',
                textAlign: 'center'
              }}>
                <div style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '8px' }}>
                  100%
                </div>
                <div style={{ fontSize: '14px', opacity: 0.9 }}>
                  Free to Join
                </div>
              </div>

              <div style={{
                background: 'white',
                border: '2px solid #e5e7eb',
                padding: '30px',
                borderRadius: '20px',
                textAlign: 'center'
              }}>
                <div style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '8px', color: '#667eea' }}>
                  24/7
                </div>
                <div style={{ fontSize: '14px', color: '#6b7280' }}>
                  Platform Support
                </div>
              </div>

              <div style={{
                background: 'white',
                border: '2px solid #e5e7eb',
                padding: '30px',
                borderRadius: '20px',
                textAlign: 'center'
              }}>
                <div style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '8px', color: '#667eea' }}>
                  Safe
                </div>
                <div style={{ fontSize: '14px', color: '#6b7280' }}>
                  Secure Platform
                </div>
              </div>

              <div style={{
                background: 'linear-gradient(135deg, #ffd700, #ffed4e)',
                color: '#333',
                padding: '30px',
                borderRadius: '20px',
                textAlign: 'center'
              }}>
                <div style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '8px' }}>
                  Pure
                </div>
                <div style={{ fontSize: '14px', opacity: 0.8 }}>
                  Brahmin Community
                </div>
              </div>
            </div>
          </Col>
        </Row>

        {/* Features Section */}
        <div style={{ marginBottom: '80px' }}>
          <h3 style={{
            fontSize: '2.5rem',
            fontWeight: 'bold',
            textAlign: 'center',
            color: '#1f2937',
            marginBottom: '60px'
          }}>
            Why Choose <span style={{ color: '#667eea' }}>OkBrahmin?</span>
          </h3>

          <Row gutter={[32, 32]}>
            {features.map((item, index) => (
              <Col xs={24} md={8} key={item.key}>
                <div style={{
                  background: 'white',
                  borderRadius: '24px',
                  padding: '40px 30px',
                  height: '100%',
                  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  border: '1px solid transparent'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.15)';
                  e.currentTarget.style.borderColor = item.color;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.1)';
                  e.currentTarget.style.borderColor = 'transparent';
                }}
                >
                  {/* Icon */}
                  <div style={{
                    width: '70px',
                    height: '70px',
                    background: `linear-gradient(135deg, ${item.color}, ${item.color}dd)`,
                    borderRadius: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '28px',
                    color: 'white',
                    marginBottom: '24px',
                    boxShadow: `0 10px 25px ${item.color}33`
                  }}>
                    {item.icon}
                  </div>

                  <h4 style={{
                    fontSize: '1.5rem',
                    fontWeight: 'bold',
                    color: '#1f2937',
                    marginBottom: '16px'
                  }}>
                    {item.title}
                  </h4>

                  <p style={{
                    color: '#6b7280',
                    lineHeight: '1.7',
                    fontSize: '16px',
                    margin: 0
                  }}>
                    {item.content}
                  </p>
                </div>
              </Col>
            ))}
          </Row>
        </div>

        {/* Call to Action */}
        <div style={{
          background: 'linear-gradient(135deg, #667eea, #764ba2)',
          borderRadius: '32px',
          padding: '60px 40px',
          textAlign: 'center',
          color: 'white',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Background decoration */}
          <div style={{
            position: 'absolute',
            top: '-50%',
            right: '-20%',
            width: '40%',
            height: '200%',
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '50%',
            transform: 'rotate(45deg)'
          }}></div>

          <div style={{ position: 'relative', zIndex: 2 }}>
            <h3 style={{
              fontSize: '2.5rem',
              fontWeight: 'bold',
              marginBottom: '16px',
              color: 'white'
            }}>
              Ready to Begin Your Journey?
            </h3>
            
            <p style={{
              fontSize: '1.2rem',
              marginBottom: '32px',
              color: 'rgba(255, 255, 255, 0.9)',
              maxWidth: '600px',
              margin: '0 auto 32px'
            }}>
              Join OkBrahmin today and connect with like-minded individuals who share your values and traditions.
            </p>

            <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Button
                type="primary"
                size="large"
                style={{
                  background: '#ffd700',
                  borderColor: '#ffd700',
                  color: '#333',
                  fontWeight: 'bold',
                  height: '56px',
                  padding: '0 32px',
                  borderRadius: '28px',
                  fontSize: '16px'
                }}
              >
                Create Your Profile
              </Button>
              
              <Button
                size="large"
                style={{
                  background: 'transparent',
                  borderColor: 'rgba(255, 255, 255, 0.3)',
                  color: 'white',
                  height: '56px',
                  padding: '0 32px',
                  borderRadius: '28px',
                  fontSize: '16px',
                  backdropFilter: 'blur(10px)'
                }}
              >
                Learn More
              </Button>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default AppAbout;